<template>
  <div class="default-sidebar">
    <!-- <div class="sidebar-title">
      <span>通用</span>
    </div> -->
    <a-menu
      :defaultSelectedKeys="[$route.meta.baseCategory || $route.meta.category]"
      :selectedKeys="[$route.meta.baseCategory || $route.meta.category]"
      class="sidebar-style"
    >
      <template v-for="item in sidebarRouter">
        <a-menu-item
          v-if="!item.meta.hidden"
          :key="item.meta.category"
          :class="{
            'default-color':
              $route.meta.category !== item.meta.category &&
              $route.meta.baseCategory !== item.meta.category
          }"
          @click="routerTo(item.name)"
        >
          <!-- <img class="icon" :src="item.meta.icon" />
          <img class="active-icon" :src="item.meta.activeIcon" /> -->
          <span>{{ $t(item.meta.title) }}</span>
        </a-menu-item>
      </template>
    </a-menu>
  </div>
</template>

<script>
export default {
  props: {
    sidebarRouter: {
      type: Array,
      required: true
    }
  },

  methods: {
    routerTo(name) {
      this.$router.push({ name })
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../style/variable.less';

.default-sidebar {
  height: 100%;
  overflow-y: auto;
  background-color: @sidebarBackColor;
  border-right: 1px solid #eee;
  .sidebar-title {
    height: @pageHeaderHeight;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bolder;
    color: #000;
  }
  .sidebar-style {
    .icon,
    .active-icon {
      margin-right: 16px;
      width: @iconWidth;
      height: @iconHeight;
      &:focus {
        outline: none;
      }
    }
  }
}
</style>

<style lang="less">
@import '../../style/variable.less';

.default-sidebar {
  .sidebar-style {
    border: 0;
    background-color: @sidebarBackColor;
    .ant-menu-item {
      color: @sidebarFontColor;
      height: @sidebarItemHeight;
      padding-left: 24px !important;
      line-height: 1;
      display: flex;
      align-items: center;
      margin: 0;
      .icon {
        display: block;
      }
      .active-icon {
        display: none;
      }
    }
    .ant-menu-item:focus {
      background-color: @sidebarBackColor;
      .icon {
        display: block;
      }
      .active-icon {
        display: none;
      }
    }
    .ant-menu-item:hover,
    .default-color.ant-menu-item-selected:hover,
    .ant-menu-item.ant-menu-item-selected {
      background-color: @sidebarActiveBacktColor;
      color: @sidebarActiveFontColor;
      .icon {
        display: none;
      }
      .active-icon {
        display: block;
      }
    }
    .default-color.ant-menu-item-selected {
      background-color: @sidebarBackColor;
      color: @sidebarFontColor;
      .icon {
        display: block;
      }
      .active-icon {
        display: none;
      }
    }
  }
}
</style>
